import React from 'react';

import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';

import InputField, { ChangeState } from './InputField';

export interface PhoneState {
  phone: string;
  isValid: boolean;
}

interface PhoneInputProps {
  onPhoneChange: ({ phone, isValid }: PhoneState) => void;
}

const PhoneInput = ({ onPhoneChange }: PhoneInputProps) => {
  const { REQUIRED_PHONE_NUMBER, PHONE_NUMBER_LABEL } = I18N_STRINGS;

  const validation = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (value.length > 0) {
      return {
        formattedValue: value,
        errorState: { error: false, message: '' },
      };
    }

    return {
      formattedValue: value,
      errorState: {
        error: true,
        message: REQUIRED_PHONE_NUMBER,
      },
    };
  };

  const onChange = ({ value, isValid }: ChangeState) => {
    onPhoneChange({ phone: value, isValid });
  };

  return (
    <InputField
      type="phone"
      id="phone"
      name="phone"
      testId="phone-field"
      className="mb-24"
      label={PHONE_NUMBER_LABEL}
      maxLength={50}
      onChange={onChange}
      validation={validation}
    />
  );
};

export default PhoneInput;
